import timg1 from '../images/team/img-1.jpg'
import timg2 from '../images/team/img-2.jpg'
import timg3 from '../images/team/img-3.jpg'
import timg4 from '../images/team/img-4.jpg'
import timg5 from '../images/team/img-5.jpg'
import timg6 from '../images/team/img-6.jpg'
import timg7 from '../images/team/img-7.jpg'
import timg8 from '../images/team/img-8.jpg'
import timg9 from '../images/team/img-9.jpg'


const Teams = [
   {
      Id: '1',
      tImg: timg1,
      name: 'Harry Tector',
      slug: 'Harry-Tector',
      title: 'Web Designer',
   },
   {
      Id: '2',
      tImg: timg2,
      name: 'Jenny Wilson',
      slug: 'Jenny-Wilson',
      title: 'Creative Design',
   },
   {
      Id: '3',
      tImg: timg3,
      name: 'Takla Murad',
      slug: 'Takla-Murad',
      title: 'Ux Designer',
   },
   {
      Id: '4',
      tImg: timg4,
      name: 'Aliza Anny',
      slug: 'Aliza-Anny',
      title: 'Ux Designer',
   },
   {
      Id: '5',
      tImg: timg5,
      name: 'David Miler',
      slug: 'David-Miler',
      title: 'React Developer',
   },
   {
      Id: '6',
      tImg: timg6,
      name: 'Thomas',
      slug: 'Thomas',
      title: 'Web Developer',
   },
   {
      Id: '7',
      tImg: timg7,
      name: 'Aliza Anny',
      slug: 'Aliza-Anny',
      title: 'Ux Designer',
   },
   {
      Id: '8',
      tImg: timg8,
      name: 'David Miler',
      slug: 'David-Miler',
      title: 'React Developer',
   },
   {
      Id: '9',
      tImg: timg9,
      name: 'Thomas',
      slug: 'Thomas',
      title: 'web Developer',
   },

]

export default Teams;